import { postRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'
import { SimpleResult } from '../../types/PaginatedResult'
import { SClassifiedMedia } from '../../types/api/Classified'
import { classifiedMediaTransformer } from '../../transformers/classifiedTransformer'

type addMediaResponse = SimpleResult<SClassifiedMedia>

export type AddMediaParams = {
  data: { [key: string]: any }
}

const addMedia = ({ data }: AddMediaParams) => {
  return postRestRequest({
    url: api.REST_API_URL + `/classified-medias`,
    data: { data },
    transformer: (response: addMediaResponse) => {
      return classifiedMediaTransformer(response.data)
    },
  })
}

export default addMedia
